import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { StatService } from '@mailer/services/StatService';

export const detailed = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc',
      datePicker: JSON.parse(localStorage.getItem('date')) || null
    },
    mutations: {
      datePicker: (state, value) => (state.datePicker = value)
    },
    actions: {
      getData: (_, params) => StatService.getDetailed(params),
      set_datePicker({ commit }, value) {
        localStorage.setItem('date', JSON.stringify(value));
        commit('datePicker', value);
      }
    },
    getters: {
      datePicker: state => state.datePicker
    }
  },
  true
);
